import Cookies from 'js-cookie';
const useAppStore = defineStore('app', {
  state: () => ({
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false,
      hide: false
    },
    rightbar: {
      opened: Cookies.get('rightbarStatus') ? !!+Cookies.get('rightbarStatus') : true,
      withoutAnimation: false,
      hide: false
    },
    device: 'desktop',
    size: Cookies.get('size') || 'default'
  }),
  actions: {
    toggleSideBar(withoutAnimation) {
      if (this.sidebar.hide) {
        return false;
      }
      this.sidebar.opened = !this.sidebar.opened;
      this.sidebar.withoutAnimation = withoutAnimation;
      if (this.sidebar.opened) {
        Cookies.set('sidebarStatus', 1);
      } else {
        Cookies.set('sidebarStatus', 0);
      }
    },
    closeSideBar(withoutAnimation) {
      Cookies.set('sidebarStatus', 0);
      this.sidebar.opened = false;
      this.sidebar.withoutAnimation = withoutAnimation;
    },
    toggleDevice(device) {
      this.device = device;
    },
    setSize(size) {
      this.size = size;
      Cookies.set('size', size);
    },
    toggleSideBarHide(status) {
      this.sidebar.hide = status;
    },
    //右侧导航栏控制方法
    toggleRightBar(withoutAnimation) {
      if (this.rightbar.hide) {
        return false;
      }
      this.rightbar.opened = !this.rightbar.opened;
      this.rightbar.withoutAnimation = withoutAnimation;
      if (this.rightbar.opened) {
        Cookies.set('rightbarStatus', 1);
      } else {
        Cookies.set('rightbarStatus', 0);
      }
    },
    closeRightBar(withoutAnimation) {
      Cookies.set('rightbarStatus', 0);
      this.rightbar.opened = false;
      this.rightbar.withoutAnimation = withoutAnimation;
    },
    toggleRightBarHide(status) {
      this.rightbar.hide = status;
    }
  }
});
export default useAppStore;